import $ from 'jquery';
import { pluginify } from 'javascripts/utils';
import { debounce } from 'lodash';

class SalesforceIdeaSearchForm {
  constructor($element, options) {
    this.$element = $element;
    this.options = options;
    this.searchInProgress = null;

    this.searchProgressIndicator = this.$element.find('.progress-indicator');
    this.ideaField = this.$element.find('#idea_id');

    this.relatedIdeas = this.$element.find('.related-ideas');
    this.relatedIdeas.on('click', 'li', event => {
      return this.selectIdea($(event.currentTarget).attr('data-idea-id'));
    });
    this.relatedIdeas.on('dblclick', 'li', event => {
      this.selectIdea($(event.currentTarget).attr('data-idea-id'));
      return this.$element.submit();
    });

    this.debouncedSearch = debounce(event => {
      this.submitSearch($(event.currentTarget).val());
      return false;
    }, 200);
    this.searchBox = this.$element.find('#ideas_idea_name');
    this.searchBox.on('keyup', this.debouncedSearch);

    this.selectButton = this.$element
      .find('#select-button')
      .prop('disabled', true);
  }

  submitSearch(searchTerm) {
    if (
      this.searchInProgress != null &&
      this.searchInProgress.readyState !== 4
    ) {
      this.searchInProgress.abort();
    }

    const categoryIdsSelectro = document.getElementById(
      'project_and_category_ids'
    );
    const selectedCategoryIds = categoryIdsSelectro?.selectro?.selected?.map(
      item => item.value
    );

    const workflowNamesSelectro = document.getElementById(
      'workflow_status_ids'
    );
    const selectedWorkflowIds = workflowNamesSelectro?.selectro?.selected?.map(
      item => item.value
    );

    return (this.searchInProgress = $.ajax({
      url: this.options.searchUrl,
      type: 'GET',
      dataType: 'script',
      data: {
        query: searchTerm,
        project_id:
          $('#ideas_idea_project_id').val() || // classic design
          $('#project_id.project-selector').val(), // new design
        project_and_category_ids: selectedCategoryIds,
        workflow_status_ids: selectedWorkflowIds,
      },
      beforeSend: () => {
        this.relatedIdeas.empty();
        this.searchProgressIndicator.show();
      },
      complete: () => {
        this.searchProgressIndicator.hide();
        this.truncate();
      },
    }));
  }

  selectIdea(ideaId) {
    this.relatedIdeas.find('li.selected').removeClass('selected');
    this.relatedIdeas.find(`li[data-idea-id='${ideaId}']`).addClass('selected');
    this.ideaField.val(ideaId);
    this.selectButton.prop('disabled', false);
  }

  truncate() {
    const charLimit = 240;

    document.querySelectorAll('div.text-block').forEach(block => {
      const textEl = block.querySelector(':scope span.text');
      const toggle = block.querySelector(':scope span.toggle');
      const fullText = textEl.textContent.trim();
      const showLess = this.options.showLessText;
      const showMore = this.options.showMoreText;

      if (fullText.length > charLimit) {
        const previewText = fullText.substring(0, charLimit) + '…';
        textEl.textContent = previewText;
        toggle.textContent = showMore;

        let expanded = false;
        toggle.addEventListener('click', () => {
          expanded = !expanded;
          textEl.textContent = expanded ? fullText : previewText;
          toggle.textContent = expanded ? showLess : showMore;
        });
      } else {
        toggle.style.display = 'none';
      }
    });
  }
}

pluginify('salesforceIdeaSearchForm', SalesforceIdeaSearchForm);
